import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Label } from "@/components/ui/label";
import { ResponsiveCommandSelect } from "@/components/ui/responsive-select";
import type { EditClientForm } from "@/lib/core/crm/types/contacts";

interface ClientStatusSectionProps {
  editForm: UseFormReturn<EditClientForm>;
  isOpen?: boolean;
  onToggle?: () => void;
  headerless?: boolean;
}

const Fields: React.FC<{ editForm: UseFormReturn<EditClientForm> }> = ({ editForm }) => (
  <>
    <Label htmlFor="edit-is_active">Status</Label>
    <ResponsiveCommandSelect
      value={editForm.watch("is_active") ? "active" : "inactive"}
      onValueChange={(val) =>
        editForm.setValue("is_active", val === "active", { shouldValidate: true })
      }
      options={[
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
      ]}
      placeholder="Select status"
      title="Client Status"
      description="Set whether this client is active or inactive"
    />
  </>
);

export const ClientStatusSection: React.FC<ClientStatusSectionProps> = ({
  editForm,
  isOpen,
  onToggle,
  headerless,
}) => {
  if (headerless) {
    return (
      <div className="space-y-2">
        <Fields editForm={editForm} />
      </div>
    );
  }
  return (
    <div className="border rounded-lg">
      <button
        type="button"
        className="w-full flex justify-between items-center px-4 py-3 bg-card-50 hover:bg-card-100 font-semibold text-left"
        onClick={onToggle}
      >
        Status
        <span>{isOpen ? "−" : "+"}</span>
      </button>
      {isOpen && (
        <div className="p-4 space-y-2">
          <Fields editForm={editForm} />
        </div>
      )}
    </div>
  );
};
